import { SelectItem } from "../../types/SelectItem";
import { RentalPremierProduct } from "../enums";

export function getPremierPrepayPenaltySelects(product: string) {
  if (
    product === RentalPremierProduct["Premier - 5/1 ARM"] ||
    product === RentalPremierProduct["Premier - 5 Year Balloon"] ||
    product === RentalPremierProduct["Premier - 5 Year, 30 Am"]
  ) {
    return selectRentalPremierPrepayment;
  } else {
    return selectRentalPremierPrepaymentFixed;
  }
}

export const selectRentalPremierProduct: SelectItem[] = [
  { label: "Premier - 5 Year, 30 Am", value: "Premier - 5 Year, 30 Am" },
  { label: "Premier - 10 Year, 30 Am", value: "Premier - 10 Year, 30 Am" },
  { label: "Premier - 5 Year Balloon", value: "Premier - 5 Year Balloon" },
  { label: "Premier - 10 Year Balloon", value: "Premier - 10 Year Balloon" },
  { label: "Premier - 5/1 ARM", value: "Premier - 5/1 ARM" },
  { label: "Premier - 30 Year Fixed", value: "Premier - 30 Year Fixed" },
];

export const selectOpenPrepay: SelectItem[] = [
  {
    label: "Open Prepayment Allowance: 0% UPB/Year",
    value: "Open Prepayment Allowance: 0% UPB/Year",
  },
  {
    label: "Open Prepayment Allowance: 5% UPB/Year",
    value: "Open Prepayment Allowance: 5% UPB/Year",
  },
];

export const selectRentalPremierPrepayment: SelectItem[] = [
  { label: "Yield Spread Maintenance", value: "Yield Spread Maintenance" },
  {
    label: "5 Year Prepayment Penalty: 5, 5, 4, 4, 3",
    value: "5 Year Prepayment Penalty: 5, 5, 4, 4, 3",
  },
  {
    label: "5 Year Prepayment Penalty: 5, 4, 3, 2, 1",
    value: "5 Year Prepayment Penalty: 5, 4, 3, 2, 1",
  },
];

export const selectRentalPremierPrepaymentFixed: SelectItem[] = [
  { label: "Yield Spread Maintenance", value: "Yield Spread Maintenance" },
  {
    label: "10 Year Prepayment Penalty: 5, 5, 4, 4, 3, 3, 2, 2, 1, 1",
    value: "10 Year Prepayment Penalty: 5, 5, 4, 4, 3, 3, 2, 2, 1, 1",
  },
  {
    label: "7 Year Prepayment Penalty: 5, 5, 4, 4, 3, 2, 1",
    value: "7 Year Prepayment Penalty: 5, 5, 4, 4, 3, 2, 1",
  },
];
